import { useCallback, useEffect, useState } from 'react';
import { DocCategoryMetaData } from '../components/card-view-content/types';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import { NWClient } from '../../../client/NWClient';
import { RootState } from '../../../store';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../../common/constants/routes';

export const useDocumentsMetaData = (activeTab?: string) => {
  const currentUser = useAppSelector(selectUser);
  const uploadingDocumentStatus = useAppSelector((state: RootState) => state.documents.status);
  const location = useLocation();
  const path = location.pathname;
  const [uploadedDocumentsMetaData, setUploadedDocumentsMetaData] = useState<DocCategoryMetaData[]>(
    []
  );
  const getDocumentsMetaData = useCallback(() => {
    const statuses = ['uploading', 'updating', 'deleting', 'loading'];
    if (
      currentUser.id &&
      statuses.every((el) => uploadingDocumentStatus !== el) &&
      path === ROUTES.DOCUMENT_VAULT &&
      activeTab === 'All'
    ) {
      NWClient.list('metadata', { user: currentUser.id }).then((res: any) => {
        if ('categories' in res) {
          setUploadedDocumentsMetaData(res.categories);
        }
      });
    }
  }, [currentUser.id, activeTab, uploadingDocumentStatus, path]);

  useEffect(() => {
    getDocumentsMetaData();
  }, [getDocumentsMetaData]);

  return {
    uploadedDocumentsMetaData,
  };
};
